import angular from 'angular'
import buyer from './buyer'
import goodsInfo from './goodsInfo'
import goodsContrast from './goodsContrast'
import smartGoods from './smartGoods'

export default angular
    .module('outputManage.ovat', [buyer, goodsInfo, smartGoods, goodsContrast])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('outputManage.ovat', {
            url: '/ovat',
            template: '<div ui-view></div>',
            abstract: true,
            title: '销项基础数据',
        })
    }])
    .name



// WEBPACK FOOTER //
// ./src/app/outputManage/baseData/index.js